export const selectTasks = (state) => state.companyTask?.tasks || [];

export const selectTaskLoading = (state) => state.companyTask?.loading || false;

export const selectTaskError = (state) => state.companyTask?.error || null;

export const selectSelectedTask = (state) =>
  state.companyTask?.selectedTask || null;

export const selectTaskUpdating = (state) =>
  state.companyTask?.updating || false;

export const selectTaskDeleting = (state) =>
  state.companyTask?.deleting || false;

export const selectTaskUpdatingStatus = (state) =>
  state.companyTask?.updatingStatus || false;

export const selectTaskFilters = (state) => state.companyTask?.filters || {};

export const selectTaskPagination = (state) =>
  state.companyTask?.pagination || {};

export const selectEmployeeTaskDateRanges =
  (state) =>
    state.companyTask
      ?.employeeTaskDateRanges || [];

export const selectTopPriorityTasks =
  (state) => state.companyTask?.topPriorityTasks || [];

export const selectTopPriorityTasksLoading =
  (state) => state.companyTask?.topPriorityTasksLoading || false;